export enum UserType {
  CUSTOMER = 'CUSTOMER',
  SELLER = 'SELLER'
}
